import React from "react";
import { Route, Redirect } from "react-router-dom";
import { connect } from "react-redux";

function RedirectRoute({ token = null, component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(props) =>
        !!token ? (
          <Redirect
            to={{ pathname: "/portal/balance", state: { from: props.location } }}
          />
        ) : (
          <Component {...props} {...rest} />
        )
      }
    />
  );
}

export default connect(({ auth: { userDetails = {} } }) => {
  let { token } = userDetails;
  return { token };
})(RedirectRoute);